import { Component, Inject, Injectable, NgModule, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventService } from "../core/services/event.service";

// utils function
import { environment } from "src/environments/environment";
import { UploadService } from '../core/services/upload.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DataService } from '../core/services/data.service';
import { ImageCroppedEvent, ImageCropperComponent, base64ToFile } from 'ngx-image-cropper';
import { Observable, ReplaySubject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AuthService } from '../core/services/auth.service';
import { EncryptionService } from '../core/services/encryption.service';
import { Platform } from '@angular/cdk/platform';
import { Device } from '@capacitor/device';


@Component({
  selector: 'app-selfie-landing-page',
  templateUrl: './selfie-landing-page.component.html',
  styleUrls: ['./selfie-landing-page.component.css'],
  encapsulation: ViewEncapsulation.Emulated

})
export class SelfieLandingPageComponent implements OnInit {
  @ViewChild(ImageCropperComponent)
  imageCropper!: ImageCropperComponent;
  compressedb64Image: any;
  compressed: any;
  selectedFiles!: File;
  delayTimeInMilliseconds = 8000; // 8 seconds delay
  eventId: any;
  eventData: any;
  imgBlob: any;
  totalImages: any;
  eventDetail: any
  isLoading = false;
  errorMessage: any = null;
  isFileLoading = false;
  selectedFileNames: string[] = [];
  uploadedCheck: boolean | undefined;
  count: any;
  imageSrc: any;
  prevImage: any = null;
  userId: any;
  uploadProgress: { [key: string]: number } = {};
  thumbnailUrls: string[] = [];
  progressPercentage: any;
 // private s3: AWS.S3;
  localFiles: string[] = [];
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageURL!: SafeUrl;
  base64Output: any;
  hideBtn: boolean = false;
  private routeSub:any;  // subscription to route observer
  sortOrder: any = 'asc';

  /** Hosts call their event an album; guests see it as the Event Gallery. */
  get albumLabel(): string {
    return localStorage.getItem('isHost') === 'true' ? 'album' : 'Event Gallery';
  }

  constructor(
    
    public dataService: DataService,
    public sanitizer: DomSanitizer,
    private uploadService: UploadService,
    private eventService: EventService,
    private router: Router, private afAuth: AngularFireAuth,
    private authService: AuthService,
    private encryptionService: EncryptionService,
    private platform: Platform,
  ) {

    this.prevImage = this.dataService.prevUserImage;
  }


  async ngOnInit(): Promise<void> {
    this.isFileLoading = false;
    await this.getSelfie();
    //this.prevImage = this.dataService.prevUserImage; 
    // console.log(localStorage.getItem('uploadedSelfie') //__CONSOLE_LOG__);

  }

  async getSelfie() {
    (await (this.eventService.getSelfie())).subscribe({
      next: (res) => {
        this.prevImage = res;
        // console.log(this.prevImage); //__CONSOLE_LOG__
      },
      error: (err) => {
        // console.error(err); //__CONSOLE_LOG__
      },
    });
  }

  goBack() {
    localStorage.removeItem('eventId');
    localStorage.setItem('access', 'open');
    this.router.navigateByUrl('/home');
  }



  async downloadApp() {
    const info = await Device.getInfo();

    if (this.platform.IOS && info.model === 'iPhone' && info.platform === 'web') {
      window.location.href = 'https://apps.apple.com/in/app/picaggo/id1527686260';
    }

    if (this.platform.ANDROID && info.platform === 'web') {
      window.location.href = 'https://play.google.com/store/apps/details?id=application.share.photo.picaggo';
    }
    
    if (!this.platform.ANDROID && !this.platform.IOS && info.platform === 'web') {
      window.location.href = 'https://picaggo.com';
    }
  }

  logout() {
    this.authService
      .signOut()
      .then((res) => {
        this.router.navigateByUrl(
          "/scan-qr"
        );
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }

  readURL(event: any): void {
    if (event.target) {
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;

      reader.readAsDataURL(file);
    }
  }

  async onFileSelected(event: any) {
    const file = event.target.files[0] as File;
    if (file && !file.type.startsWith('image/')) {
      this.errorMessage = 'Please choose an image file (PNG, JPG or WEBP).';
      event.target.value = '';
      return;
    }

    localStorage.setItem('uploadedSelfie', 'true');
    this.errorMessage = null;
    this.hideBtn = false;
    this.imageChangedEvent = event;

    this.selectedFiles = event.target.files[0] as File;
    this.selectedFileNames = [];
    this.uploadProgress[this.selectedFiles.name] = 0;
    this.selectedFileNames.push(this.selectedFiles.name);
    this.prevImage = null;
    this.readURL(event);

  }

  removeImage() {
    this.prevImage = null;
    this.imageSrc = null;
    this.imageURL = '/assets/icon/noun-selfie-large.png';
    this.errorMessage = null;
    this.imageChangedEvent = '';
    this.hideBtn = true;
    //console.log(this.selectedFiles)
    // console.log(this.isFileLoading) //__CONSOLE_LOG__
  }


  blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // console.log(theBlob); //__CONSOLE_LOG__

    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return theBlob as File;
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event: any) => result.next(btoa(event.target.result.toString()));
    return result;
  }


  async uploadImage() {
    this.count = 0;
    this.isFileLoading = true;
    this.errorMessage = null;

    if (!this.selectedFiles && this.prevImage == null) {
      // console.error('No file selected.'); //__CONSOLE_LOG__
      this.isFileLoading = false;
      //  this.closeDialog(null);
      return;
    }
    else if (!this.selectedFiles && this.prevImage != null) {
      this.uploadedCheck = false;
      (await this.eventService.getMyPictures('0', '10', localStorage.getItem('eventId'),'all','null', this.sortOrder)).subscribe({
        next: (res: any) => {
          if (!res.error) {
            this.eventDetail = [];
            this.errorMessage = null;
            this.isFileLoading = false;
            localStorage.removeItem('uploadedSelfie');
            this.router.navigateByUrl('/gallery/' + localStorage.getItem('eventId'))
          }
          else if (res.error) {
            this.isFileLoading = false;
            this.errorMessage = res.error.message ?? res.error;
          }
        },
        error: (err) => {
          this.isFileLoading = false;
          this.errorMessage = null;
          // console.error(err); //__CONSOLE_LOG__
        },
      })
    }
    else {
      this.uploadedCheck = false;

      (await this.uploadService.uploadMyFace(this.base64Output,null,null,'null')).subscribe({
        next: (res: any) => {
          // console.log(res.errorMsg) //__CONSOLE_LOG__
          if (!res.errorMsg) {
            this.isFileLoading = false;
            this.eventDetail = [];
            this.errorMessage = null;
            this.router.navigateByUrl('/gallery/' + localStorage.getItem('eventId'))

          }
          else {
            this.isFileLoading = false;
            this.errorMessage = res.errorMsg;
          }
        },
        error: (err) => {
          this.errorMessage = null;
          // console.error(err); //__CONSOLE_LOG__
        },
      });

    }
  }


  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    // console.log(event); //__CONSOLE_LOG__
    this.imgBlob = event?.blob;
    let myFile = this.blobToFile(this.imgBlob, this.selectedFileNames[0]);
    // console.log(myFile); //__CONSOLE_LOG__
    this.selectedFiles = myFile;
    this.convertFile(this.selectedFiles).subscribe((base64: any) => {
      this.base64Output = base64;
    });
    this.croppedImage = event.objectUrl;
    this.imageURL = this.sanitizer.bypassSecurityTrustUrl(this.croppedImage);
  }
  imageLoaded() {
    /* show cropper */
  }
  cropperReady() {
    /* cropper ready */
  }
  loadImageFailed() {
    /* show message */
  }
}
